<div *ngFor="let formTemplateSectionPart of formTemplateSection; index as j">
  <ng-container *ngIf="isSubSection">
    <div class="title" [innerHTML]="formTemplateSectionPart.value | safeHtml"></div>
    <div
      *ngIf="formTemplateSectionPart.formTemplateSectionType.name !== FormTemplateSectionType.Text"
      class="qus-wrap"
    >
      <ng-container *ngFor="let question of formTemplateSectionPart.formTemplateQuestions">
        <ng-container *ngIf="!isFormTemplateSection(question)">
          <app-form-completion-template-question
            [formTemplateQuestion]="question"
            [isGroupedQuestion]="true"
          ></app-form-completion-template-question>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="!isSubSection">
    <ng-container *ngIf="j === 0">
      <h2
        *ngIf="formTemplateSectionPart.value"
        [innerHTML]="formTemplateSectionPart.value | safeHtml"
        [ngStyle]="{
          background: themeService.getThemeColor(themeService.ThemeItemEnum.sectionHeader)
        }"
      ></h2>
    </ng-container>
    <ng-container *ngIf="j > 0 && formTemplateSectionPart.value !== '<FORCE_SECTION>'">
      <div class="txt">
        <p [innerHTML]="formTemplateSectionPart.value | safeHtml"></p>
      </div>
    </ng-container>
    <div
      *ngIf="formTemplateSectionPart.formTemplateSectionType.name !== FormTemplateSectionType.Text"
      class="form-section"
      [ngClass]="contentDirection(formTemplateSectionPart)"
      [class.check-wrap]="contentDirection(formTemplateSectionPart) === sectionDirection.Horizontal"
    >
      <ng-container
        *ngFor="let question of formTemplateSectionPart.formTemplateQuestions; index as i"
      >
        <ng-container *ngIf="!isFormTemplateSection(question)">
          <app-form-completion-template-question
            [ngClass]="questionContainer(question)"
            [formTemplateQuestion]="question"
          ></app-form-completion-template-question>
        </ng-container>
        <ng-container *ngIf="isFormTemplateSection(question)">
          <ng-container
            *ngTemplateOutlet="subSectionTemplate; context: { formTemplateSection: question }"
          ></ng-container>
        </ng-container>
        <div
          *ngIf="hasRowBreakAfter(formTemplateSectionPart, i)"
          class="row-break"
          aria-hidden="true"
        ></div>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #subSectionTemplate let-formTemplateSection="formTemplateSection">
  <app-form-completion-template-section
    [formTemplateSection]="[formTemplateSection]"
    [isSubSection]="true"
  />
</ng-template>
